// extracted by mini-css-extract-plugin
export var bubble = "_3q-0";
export var container = "_3q-f";
export var contrastBorder = "_3q-g";
export var greyOut = "_3q-2";
export var initialsColor0 = "_3q-3";
export var initialsColor1 = "_3q-4";
export var initialsColor10 = "_3q-d";
export var initialsColor11 = "_3q-e";
export var initialsColor2 = "_3q-5";
export var initialsColor3 = "_3q-6";
export var initialsColor4 = "_3q-7";
export var initialsColor5 = "_3q-8";
export var initialsColor6 = "_3q-9";
export var initialsColor7 = "_3q-a";
export var initialsColor8 = "_3q-b";
export var initialsColor9 = "_3q-c";
export var initialsWrapper = "_3q-1";
export var large = "_3q-l";
export var medium = "_3q-k";
export var mediumSmall = "_3q-j";
export var mediumSmallMedium = "_3q-o";
export var micro = "_3q-h";
export var small = "_3q-i";
export var tiny = "_3q-n";
export var xTiny = "_3q-m";